import { Component, ViewChild } from '@angular/core';

import { KeyboardEventCode } from '@core/common-legacy/keyboard';
import { TranslatePipe } from '@core/i18n-legacy';
import type { PlaceholderNavigationKey } from '@core/prosemirror-legacy';
import type { Placeholder } from '@core/wysiwyg-legacy';
import { PlaceholderCategorySelectDropdownComponent } from '@core/wysiwyg-legacy';

import { PlaceholderDropdownTypeaheadComponent } from '../placeholder-dropdown-typeahead/placeholder-dropdown-typeahead.component';

@Component({
  selector: 'rt-placeholder-dropdown',
  templateUrl: './placeholder-dropdown.component.html',
  styleUrls: ['./placeholder-dropdown.component.less'],
  host: {
    '(keyup)': 'onKeyUp($event)',
    '(keydown)': 'onKeyDown($event)',
  },
  imports: [
    PlaceholderDropdownTypeaheadComponent,
    PlaceholderCategorySelectDropdownComponent,
    TranslatePipe,
  ],
})
export class PlaceholderDropdownComponent {
  public nestedList: boolean;
  public select: (val: Placeholder) => void;
  public close: () => void;
  public data: Placeholder[] = [];

  @ViewChild(PlaceholderDropdownTypeaheadComponent)
  private placeholderDropdownTypeaheadComponent: PlaceholderDropdownTypeaheadComponent;

  public onKeyUp(event: KeyboardEvent) {
    this.handleKey(<PlaceholderNavigationKey>event.key);
  }

  public onKeyDown(event: KeyboardEvent) {
    if (KeyboardEventCode.Escape === event.key) {
      event.stopPropagation();
      this.close();
    }
  }

  public handleKey(key: PlaceholderNavigationKey): void {
    this.placeholderDropdownTypeaheadComponent.handleKey(key);
  }
}
